import { v4 as uuidv4 } from "uuid";

export const isMobileDevice = (): boolean => {
  return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
};

export const isPcDevice = (): boolean => {
  const userAgent = navigator.userAgent.toLowerCase();
  return !/iphone|ipad|ipod|android|mobile/.test(userAgent);
};

export const isIOSDevice = (): boolean => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
};

export const isAndroidDevice = (): boolean => {
  return /android/i.test(navigator.userAgent);
};

// 工具函数
export const isIOSandNotOnPC = (): boolean => {
  if (!navigator.share) {
    return false;
  }
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
  const isNotPC = !(
    navigator.userAgent.match(/(Mac|Windows)/) &&
    !navigator.userAgent.match(/Mobile/)
  );
  return isIOS && isNotPC;
};

// 判断是否在微信浏览器中
export const isWxWeb = (): boolean => {
  const ua = window.navigator.userAgent.toLowerCase();
  return ua.indexOf("micromessenger") !== -1;
};

export const seaShareUrl = `${process.env.VUE_APP_SHARE_API}/share_html`;

export function downloadImage(imageUrl: any, fileName = '') {
  const uuid = uuidv4();
  // 创建一个隐藏的a标签
  const link = document.createElement("a");

  // 处理文件名（默认使用链接中的文件名或随机名称）
  let name = fileName;
  if (!name) {
    // 从URL中提取文件名
    name = `kl-event-${+new Date()}${uuid}.jpg`  || "downloaded-image";
  }

  // 设置a标签属性
  link.href = imageUrl;
  // 设置下载文件名（浏览器会自动添加正确的扩展名）
  link.download = name;

  // 将a标签添加到页面并触发点击
  document.body.appendChild(link);
  link.click();

  // 清理：移除a标签
  setTimeout(() => {
    document.body.removeChild(link);
  }, 0);
}